import { initAdobeDataLayerMMT } from '@mmt/event-logger';

export const initializeAdobeDataLayer = () => {
    const env = process.env.REACT_APP_ENV === 'production' ? 'production' : 'development';

    // Get the script URL
    const scriptTag = initAdobeDataLayerMMT(env);
    const scriptUrl = scriptTag.match(/src="([^"]+)"/)[1];

    // Create and append the script element
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;

    // Add load event listener to verify initialization
    script.onload = () => {
        if (window.adobeDataLayer) {
            // eslint-disable-next-line no-console
            console.log('Adobe Data Layer initialized successfully');
        } else {
            // eslint-disable-next-line no-console
            console.log('Adobe Data Layer initialization failed');
        }
    };

    document.head.appendChild(script);
}; 